/**
 * Object of possible Vendor Application Statuses
 */

const ApplicationStatus = {
  REJECTED: 'Rejected',
  APPROVED: 'Approved',
  PENDING_APPROVAL: 'Pending Approval',
  PENDING_RE_APPROVAL: 'Pending Re-Approval',
};

export default ApplicationStatus;
